// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSessionDocAssemble,getAnswerDocAssemble } from '@api';

export const getSession = createAsyncThunk('eligibility/getSession', async args => {
    const response = await getSessionDocAssemble({interviewName:args});
    return response.data;
  })

  export const getAnswer = createAsyncThunk('eligibility/getAnswer', async args => {
    const response = await getAnswerDocAssemble({session:args});
    return response.data;
  })
  
  
export const eligibilityCheckSlice = createSlice({
    name: 'eligibility',
    initialState: {
        session: '',
    },
    reducers:{},
    extraReducers: builder => {
        builder
          .addCase(getSession.fulfilled, (state, action) => {
           
            state.session = action.payload;
          })
          
      }

})

//export const {} = eligibilityCheckSlice.actions

export default eligibilityCheckSlice.reducer